<template>

    <main class="search-results">

        <div
                class="search-results-inner"
        >

            <h1 class="heading">Suchergebnisse für „{{searchTerm}}“</h1>

            <!--<h2 v-if="results.length === 0">
                Es wurden keine Treffer gefunden.
            </h2>-->

            <tabbed-teaser v-if="searchResults.length > 0" :teaser-filter-params="computedTeaserFilterParams" :show-categories-filter-param="false" :all-posts-data="searchResults" :categories-data="categoriesFromRoot"></tabbed-teaser>

        </div>

    </main>

</template>

<script>

    // console.log('SearchResults');

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    import escapeStringRegexp from 'escape-string-regexp';

    import wpApi from '../services/wpApi';

    import LoadingSpinner from './LoadingSpinner.vue';
    import TabbedTeaser from './TabbedTeaser.vue';

    export default {
        mixins : [smoothReflow],
        created(){
            this.$root.states.searchResultsAreShown = true;
			this.$root.states.previousSearchValue = this.searchTerm;
        },
        destroyed(){
			this.$root.states.searchResultsAreShown = false;
        },
        mounted(){
            this.$smoothReflow({
                transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
            });
        },
        components : {
            LoadingSpinner,
            TabbedTeaser
        },
        computed : {
			computedTeaserFilterParams() {
				return {
					...this.teaserFilterParams,
					search: this.searchTerm
				};
			},
			categoriesFromRoot() {
				// Get categories from $root.cache or return empty array
				return this.$root?.cache?.categories || [];
			}
		},
        data(){
            return {
                wpApi,
            };
        },
        props : {
			searchTerm: {
				type: String,
				default: ''
			},
			searchResults: {
				type: Array,
				default: () => []
			},
			totalResults: {
				type: Number,
				default: 0
			},
            'searchResultsMaxItems' : {
                default : 100,
                type : Number,
            },
            'teaserFilterParams' : {
                default : ()=>{
                    return {};
                },
                type : Object,
            },
        },
        metaInfo(){
            return {
                title : `Suche: ${this.searchTerm}`,
            };
        },
        methods : {
            load(){
                // NO API CALLS - Component not used in WordPress-rendered mode
                console.warn('SearchResults: load() - All data must come from PHP props, no API calls allowed');
                return;
                if (this.$route.params['term'].length) {
                    this.$root.states.previousSearchValue = this.$route.params['term'];
                    this.teaserFilterParams['search'] = this.$route.params['term'];
                    this.isLoaded = true;
                    /* wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/posts?search=' + this.$route.params['term'] + '&per_page=' + this.searchResultsMaxItems)
                        .then((response)=>{
                            console.log('response', response);
                            this.results = response['data']
                                .map((result)=>{
                                    result.highlightedContent = this.getHighlightedContent(result, this.$route.params['term']);
                                    return result;
                                })
                                .filter((result)=>!!result.highlightedContent)
                                .filter((result)=>result['acf']['visibility_published'])
                            ;
                            this.isLoaded = true;
                            window.setTimeout(()=>{
                                this.$ga.page(this.$route.fullPath);
                            });
                        })
                        .catch((error)=>{
                            console.log('error', error);
                            // this.$router.push('/404');
                        });*/
                }
            },
            getHighlightedContent(result, term){

                // IMPORTANT: This implementation should be considered a draft ...

                const regExp = new RegExp('\\b' + escapeStringRegexp(term) + '\\b', 'gi');
                // const regExp = new RegExp('(^|\\s)' + escapeStringRegexp(term) + '(\\s|$)', 'gi');

                let content, match;
                content = this.getFieldValues(result['acf'], this.resultMatchContentComposerFields)
                    .map((value)=>{
                        return this.stripHtml(value);
                    })
                    .filter((value)=>{
                        return !!value.length;
                    })
                    .join(' … ');
                match = regExp.exec(content);
                if (!match) {
                    content = this.getFieldValues(result['acf'], this.resultMatchFields)
                        .map((value)=>{
                            return this.stripHtml(value);
                        })
                        .filter((value)=>{
                            return !!value.length;
                        })
                        .join(' … ');
                    match = regExp.exec(content);
                }
                if (!match) {
                    return '';
                }

                const shortenedContent = this.shortenText(
                    content,
                    match.index,
                    match.index + term.length,
                    this.SEARCH_RESULT_STRING_LENGTH,
                );
                // const shortenedContent = this.shortenText(
                //     content,
                //     match.index,
                //     match.index + term.length,
                //     this.SEARCH_RESULT_STRING_LENGTH_BEFORE_MATCH,
                //     this.SEARCH_RESULT_STRING_LENGTH_AFTER_MATCH,
                // );

                const highlightedContent = shortenedContent.replace(regExp, (string)=>`<span class="search-highlight">${string}</span>`);

                return (' … ' + highlightedContent + ' … ').replace(/( … ){2,}/g, ' … ');
            },
            getFieldValues(data, fields){
                let values = [];
                Object.keys(data)
                    .filter((key)=>{
                        return fields.indexOf(key) > -1
                    })
                    .forEach((key)=>{
                        if (Array.isArray(data[key])) {
                            data[key].forEach((value)=>{
                                values = values.concat(this.getFieldValues(value, fields));
                            });
                            return;
                        }
                        if (typeof data[key] === 'object') {
                            values = values.concat(this.getFieldValues(data[key], fields));
                            return;
                        }
                        values.push(data[key]);
                    });
                return values;
            },
            shortenText(text, positionBefore, positionAfter, maxLength, boundary = ' '){
                let length = 0;
                let indexOfBefore;
                let indexOfAfter;
                while (positionAfter - positionBefore < maxLength && positionAfter - positionBefore !== length) {
                    length = positionAfter - positionBefore;
                    indexOfBefore = text.lastIndexOf(boundary, positionBefore - boundary.length - 1);
                    indexOfAfter = text.indexOf(boundary, positionAfter + boundary.length);
                    positionBefore = indexOfBefore > -1 ? indexOfBefore : 0;
                    positionAfter = indexOfAfter > -1 ? indexOfAfter : text.length;
                }
                return text.substring(positionBefore, positionAfter);
            },
            // shortenText(text, positionBefore, positionAfter, maxLengthBefore, maxLengthAfter, boundary = ' '){
            //     const textBefore = this.shortenTextBefore(text.substring(0, positionBefore), maxLengthBefore, boundary);
            //     const textAfter = this.shortenTextAfter(text.substr(positionAfter), maxLengthAfter, boundary);
            //     return textBefore + text.substring(positionBefore, positionAfter) + textAfter;
            // },
            // shortenTextBefore(text, length, boundary = ' '){
            //     if (text.length <= length) {
            //         return text;
            //     }
            //     return text.substr(text.indexOf(boundary, text.length - length), length);
            // },
            // shortenTextAfter(text, length, boundary = ' '){
            //     if (text.length <= length) {
            //         return text;
            //     }
            //     return text.substr(0, text.lastIndexOf(boundary, length));
            // },
            stripHtml(html){
                const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
                return (parsedDocument.body.textContent || '').replace(/\s/g, ' ').replace(/ {2,}/g, ' ').trim();
            },
            terminateSearch(){
                this.$root.states.searchResultsAreShown = false;
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .search-results {
        overflow: hidden;
        will-change: height;
        a {
            &,
            &:hover {
                text-decoration: none;
            }
        }
        .search-results-inner {
            padding-top: 5.5rem;
            padding-bottom: 3.5rem;
            @media screen and (min-width: 1200px) {
                padding-top: 5.5rem * $factor-1200;
                padding-bottom: 3.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-top: 5.5rem * $factor-1200;
                padding-bottom: 3.5rem * $factor-1200;
            }
            @media screen and (min-width: 1920px) {
                padding-top: 5.5rem * $factor-1200;
                padding-bottom: 3.5rem * $factor-1200;
            }
            @media screen and (min-width: 2400px) {
                padding-top: 5.5rem * $factor-1200;
                padding-bottom: 3.5rem * $factor-1200;
            }
            .heading{
                margin-left: 1.5rem;
                @media screen and (min-width: 1200px) {
                    margin-left: 1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-left: 1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-left: 1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-left: 1.5rem * $factor-2400;
                }
            }
        }
        .search-highlight {
            color: $color-nochvielvor-black;
            font-weight: bold;
        }
        .heading {
            margin: 4rem 0;
            color: $color-nochvielvor-pink;
            font-size: 2.25rem;
            font-weight: bold;
            text-transform: uppercase;
            @media screen and (max-width: 767px) {
                margin: 0 0 4rem * $factor-720 0;
                font-size: 2.25rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                margin: 4rem * $factor-1200 0;
                font-size: 2.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 4rem * $factor-1440 0;
                font-size: 2.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 4rem * $factor-1920 0;
                font-size: 2.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 4rem * $factor-2400 0;
                font-size: 2.25rem * $factor-2400;
            }
        }
    }

</style>
